
import { styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';

const BootstrapInput = styled(InputBase)(({ theme, error }) => ({
    label: {
      marginTop: theme.spacing(-10),
    },
    '& .MuiInputBase-input': {
      borderRadius: 10,
      position: 'relative',
      backgroundColor: theme.palette.mode === 'light' ? 'white' : '',
      border: '1px solid',
      borderColor: `${
        error ? 'red' : theme.palette.mode === 'light' ? '#CDCDCD' : ''
      }`,
      fontSize: 16,
      padding: '5px 12px',
      height: '45px'
  
      // Use the system font instead of the default Roboto font.
    },
  }));

  export default BootstrapInput;
  
  export const selectOptionStyle = {
    maxHeight: '300px'
        }